<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
html,
body {
    width: 100%;
    height: 100%;
    #app {
        font-family: "MicrosoftYaHei", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100%;
        position: relative;
    }
    #edui_fixedlayer {
        z-index: 9999 !important;
    }
}
</style>

